// Eigenes, anonymes Website-Tracking (DSGVO-freundlich: keine Cookies, keine IP,
// keine User-Kennung). Zaehlt Seitenaufrufe und Interaktionen fuer das Admin-Dashboard.
import { API } from "./api";

const send = (payload) => {
  try {
    fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* Tracking darf nie die Nutzung stoeren */
  }
};

const isAdminPath = (p) => (p || "").startsWith("/admin");

export const trackPageview = (path) => {
  if (isAdminPath(path)) return;
  send({ type: "pageview", path, referrer: document.referrer || "" });
};

export const trackEvent = (type, label = "") => {
  if (isAdminPath(window.location.pathname)) return;
  send({ type, path: window.location.pathname, label });
};
